<template lang="pug">
.transfer-tab(v-if="show" :class="tabClass" :style="backgroundStyle")
  .tab-item(
    v-for="(tab, index) in tabs"
    :key="index"
    :class="getTabClass(index)"
    @click="handleTabClick(index, tab.tabKey)"
  )
    .tab-content
      .tab-title(
        :style="getTabTitleStyle(index)"
      ) {{tab.title}}
        img.tab-logo(:src="tab.logoImg" v-if="isShowLogo(tab)")
      .sub-title(
        :style="getTabSubTitleStyle(index)"
        v-if="tab.subTitle") {{tab.subTitle}}
</template>

<script>
import {
  TabMiandanLeft,
  TabMiandanRight,
  TabSelectedMiddleFreeRightsImg,
  TabRightNormalImg,
  ThreeTabCommonRightImg,
  ThreeTabCommonMidImg,
  ThreeTabCommonLeftImg,
  TabEbikeLeftImg,
} from '@/assets/imgAssets';


// 根据当前激活的tab，配置未激活tab的标题和子标题颜色
const TAB_INACTIVE_COLORS = {
  rideCard: {
    title: '#fff',
    subTitle: '#b5d2ff',
  },
  vip: {
    title: '#000',
    subTitle: '#242729',
  },
  oneCentVip: {
    title: '#441D06',
    subTitle: '#8E6751',
  },
  freeRights: {
    title: '#fff',
    subTitle: '#b5d2ff',
  },
};

export default {
  name: 'TransferTab',
  props: {
    // 是否显示组件
    show: {
      type: Boolean,
      default: true,
    },
    // 当前激活的tab的key
    activeTabKey: {
      type: String,
      default: '',
    },
    // tab配置数组
    tabs: {
      type: Array,
      default: () => [
        { title: '' },
        { title: '' },
      ],
    },
    // 是否在App环境
    isApp: {
      type: Boolean,
      default: null,
    },
    tabCode: {
      type: String,
      default: '',
    },
  },
  inject: ['freeRightsVersion'],
  data() {
    return {
      TAB_INACTIVE_COLORS,
    };
  },
  computed: {
    tabClass() {
      const classes = [];

      // 根据isApp属性添加类名
      if (this.isApp === false) {
        classes.push('not-app');
      } else if (this.isApp === true) {
        classes.push('is-app');
      }

      return classes.join(' ');
    },
    // 根据tab数量获取对应的图片数组
    tabImages() {
      const tabCount = this.tabs.length;
      if (this.freeRightsVersion()) {
        if (tabCount === 3) {
          return [ThreeTabCommonLeftImg, TabSelectedMiddleFreeRightsImg, ThreeTabCommonRightImg];
        }
        if (tabCount === 2) {
          return [TabMiandanLeft, TabMiandanRight];
        }
      }

      if (tabCount === 3) {
        return [ThreeTabCommonLeftImg, ThreeTabCommonMidImg, ThreeTabCommonRightImg];
      }
      if (tabCount === 2) {
        if (this.tabCode === 'ebike') {
          return [TabEbikeLeftImg, TabRightNormalImg];
        }
        return [TabMiandanLeft, TabRightNormalImg];
      }

      // 默认情况，回退到原来的单双数逻辑
      return [TabMiandanLeft, TabMiandanRight];
    },
    // 根据tab数量和当前选中的index返回对应的背景图片
    backgroundStyle() {
      const images = this.tabImages;
      const activeIndex = this.getActiveIndex();

      // 如果是默认情况（非2或3个tab），使用单双数逻辑
      if (this.tabs.length !== 2 && this.tabs.length !== 3) {
        return { backgroundImage: `url(${images[activeIndex % 2]})` };
      }

      return { backgroundImage: `url(${images[activeIndex]})` };
    },
    // 未激活tab的颜色
    inactiveSubtitleColors() {
      if (this.freeRightsVersion()) {
        return TAB_INACTIVE_COLORS.freeRights;
      }
      return TAB_INACTIVE_COLORS[this.activeTabKey] || {
        title: '#ffffff',
        subTitle: '#b5d2ff',
      };
    },
  },
  created() {
    // 预加载背景图片
    this.preloadBackgroundImages();
  },
  mounted() {
    // 组件挂载完成
  },
  methods: {
    // 预加载背景图片
    preloadBackgroundImages() {
      // 目前图片多了 后面要优化下
      const imageUrls = [
        TabMiandanLeft,
        TabMiandanRight,
        TabSelectedMiddleFreeRightsImg,
        TabRightNormalImg,
        ThreeTabCommonRightImg,
        ThreeTabCommonMidImg,
        ThreeTabCommonLeftImg,
      ];

      imageUrls.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    },
    isActive(index) {
      const tab = this.tabs[index];
      return tab && tab.tabKey === this.activeTabKey;
    },
    // 根据当前选中的tabKey获取对应的index
    getActiveIndex() {
      const index = this.tabs.findIndex((tab) => tab.tabKey === this.activeTabKey);
      return index >= 0 ? index : 0; // 如果没找到，默认返回0
    },
    getTabClass(index) {
      const classes = [];

      if (this.isActive(index)) {
        classes.push('active');
      } else {
        classes.push('inactive');
      }

      return classes.join(' ');
    },
    handleTabClick(index, tabKey) {
      if (!this.isActive(index)) {
        this.$emit('change', { tabKey });
      }
    },
    // 获取tab标题的样式
    getTabTitleStyle(index) {
      return this.isActive(index) ? {} : { color: this.inactiveSubtitleColors.title };
    },
    getTabSubTitleStyle(index) {
      return this.isActive(index)
        ? {}
        : { color: this.inactiveSubtitleColors.subTitle };
    },
    // 控制logo显示逻辑
    isShowLogo(tab) {
      if (!tab.logoImg) {
        return false;
      }
      if (this.tabs.length === 3) {
        return tab.tabKey === 'oneCentVip';
      }
      if (this.tabs.length === 2) {
        return true;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.transfer-tab {
  width: 100%;
  display: flex;
  font-family: PingFangSC, sans-serif;
  // transform: translateY(0.01rem);
  height: 0.42rem;
  margin-top: 0.88rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  align-items: center;
  justify-content: center;

  // 非App环境下的margin-top调整
  &.not-app {
    margin-top: 0.16rem;
  }

  .tab-item {
    height: 0.42rem;
    border-radius: 0.16rem 0.16rem 0 0;
    flex: 1;
    position: relative;

    .tab-content {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      overflow: visible;

      .tab-title {
        display: flex;
        flex-direction: row;
        align-items: center;

        .tab-logo {
          height: 0.16rem;
          object-fit: contain;
          margin-left: 0.02rem;
        }
      }
    }

    &.active {
      z-index: 2; /* 激活的z-index较高 */

      .tab-title {
        // line-height: 0.42rem;
        color: #000;
        font-size: 0.16rem;
        font-family: "PingFang SC", sans-serif;
        font-weight: 800;
      }

      .sub-title {
        color: #242729;
        font-size: 0.1rem;
      }
    }

    &.inactive {
      z-index: 1; /* 未激活的z-index较低 */

      .tab-title {
        font-family: "PingFang SC", sans-serif;
        font-size: 0.14rem;
        // color: #fff;
        // line-height: 0.42rem;
        font-weight: 500;
      }

      .sub-title {
        // color: #b5d2ff;
        font-size: 0.1rem;
      }
    }
  }
}

.free-rights-version {
  .tab-item {
    &.active {
      // 激活状态 - 单数tab
      &:nth-child(odd) {
        .tab-title {
          font-size: 0.16rem;
          font-weight: 600;
        }
      }

      // 激活状态 - 双数tab
      &:nth-child(even) {
        .tab-title {
          color: #141c2f;
          font-size: 0.16rem;
          font-weight: 600;
        }
      }
    }

    &.inactive {
      // 非激活状态 - 单数tab
      &:nth-child(odd) {
        color: #fff;

        .tab-title {
          color: #ffe8de;
          font-size: 0.14rem;
          font-weight: 600;
        }
      }

      // 非激活状态 - 双数tab
      &:nth-child(even) {
        color: #fff;
        border-radius: 0 0.16rem  0 0;

        .tab-title {
          color: #fff;
          font-size: 0.14rem;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
